import { render, staticRenderFns } from "./iconSettings.vue?vue&type=template&id=524f748c&scoped=true"
import script from "./iconSettings.vue?vue&type=script&lang=js"
export * from "./iconSettings.vue?vue&type=script&lang=js"
import style0 from "./iconSettings.vue?vue&type=style&index=0&id=524f748c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f748c",
  null
  
)

export default component.exports